export enum ResourseNames {
  therapists = 'therapists',
  therapistsRequests = 'therapists/requests',
  therapistsProfileUpdates = 'therapists/profile-updates',
  patients = 'patients',
  companies = 'b2b/companies',
  companiesRequests = 'b2b/requests',
  b2bMaterials = 'b2b/materials',
  groupCallLinks = 'b2b/group-call-links',
  content = 'content',
  contentFeedback = 'content/feedback',
  admins = 'admins',
  diseases = 'diseases',
  diseasesGroup = 'diseases/group',
  therapyMethods = 'therapy_methods',
  faqGroup = 'faq/group',
  faqQuestions = 'faq/question',
  statisticsSessions = 'statistics/sessions',
  statisticsPromotedSessions = 'statistics/sessions-promoted',
  statisticsTherapists = 'statistics/therapists',
  statisticsPromocodes = 'statistics/therapists/promocodes',
  b2bStats = 'b2b/stats',
  reusablePromocodes = 'promocodes',
  apiKeys = 'api-keys',
  webhooks = 'webhooks',
  searchStatistics = 'search-statistics',
  statisticsClients = 'statistics/clients',
  currencies = 'payment-gateway/currencies',
  paymentLinkCreate = 'payment-link/create',
  paymentLinkList = 'payment-link',
  promocodes = 'promocodes',
  sessions = 'sessions',
  sessionBalances = 'session-balances',
}

export interface Query<T> {
  isLoading?: boolean;
  data?: T extends {} ? T : any;
  error?: any;
}
